import { Box, Button, MenuItem, Stack, TextField, Typography } from "@mui/material"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { useStats } from "react-instantsearch-core"

import useResponsive from "@sap/hooks/useResponsive"

import { ItemsContext } from "@/pages/items/context"
import { SortByContext } from "@/utils/algolia"

export default function Header() {
  const { t } = useTranslation("items")
  const downMd = useResponsive("down", "md")
  const { showFilters, setShowFilters } = useContext(ItemsContext)

  const { nbHits, query } = useStats()

  const { currentRefinement, options, refine } = useContext(SortByContext)

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        paddingX: 0,
        paddingY: 2,
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Box>
          {query && (
            <Typography
              variant="body1"
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {t("ResultsFor")} <strong>{query}</strong>
            </Typography>
          )}
          {!downMd && (
            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
              }}
            >
              {nbHits || 0} {t("Results")}
            </Typography>
          )}
        </Box>

        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: "text.secondary",
              whiteSpace: "pre",
            }}
          >
            {t("SortBy")}:
          </Typography>

          <TextField
            select
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Short by"
            value={currentRefinement}
            onChange={(event) => refine(event.target.value)}
            sx={{
              flex: "1 1 0",
              minWidth: "150px",
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.label} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </Stack>
      {downMd && (
        <Button
          variant="soft"
          fullWidth
          color="primary"
          size="large"
          onClick={() => setShowFilters(!showFilters)}
        >
          {t("FilterResults", { count: nbHits || 0 })}
        </Button>
      )}
    </Stack>
  )
}
